import Entry from "./Entry.js";

/**
 * `file` is a concrete implementation of `entry` representing a
 * file.
 *
 * @param {int} [spec.size=0] - Size of the file
 * @param {boolean} [spec.isPreliminary=false] - Is the document a work in progress?
 */
export default class File extends Entry {
	constructor({ size = 0, isPreliminary = false } = {}) {
		super(...arguments);
		this._size = size;
		this._isPreliminary = isPreliminary;
	}

	size() {
		return this._size;
	}

	type() {
		return "File";
	}

	isFile() {
		return true;
	}

	isPreliminary() {
		return this._isPreliminary;
	}

	_buildWidgetFor(aView, position) {
		return aView.buildFileWidgetFor(this, position);
	}

	_serializedProperties() {
		const data = super._serializedProperties();

		data.isPreliminary = this._isPreliminary;

		return data;
	}
}
